export const ItemStatsColumns = [
  {
    id: "date",
    title: "Date",
  },
  {
    id: "customer_name",
    title: "Customer",
  },
  {
    id: "invoice_no",
    title: "Invoice No",
  },
  {
    id: "item_name",
    title: "Item",
  },
  {
    id: "qty",
    title: "Quantity",
  },

  {
    id: "price",
    title: "Price",
  },
  {
    id: "amount",
    title: "Total Amount",
    type: "ItemStats",
  },
];
